<script setup>
import { computed } from 'vue';
import TechnicalPropertyInfo from 'components/competitor-app-v2/technical-properties/TechnicalPropertyInfo.vue';
import ChromaHueChart from 'components/competitor-app-v2/technical-properties/ChromaHueChart.vue';

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  color: {
    type: String,
    required: false,
    default: '#7a7a7a',
  },
});

const byApplicationType = computed(() => {
  const result = {};

  Object.values(props.data).forEach((properties) => {
    properties.forEach((property) => {
      if (!result[property.applicationType]) {
        result[property.applicationType] = {};
      }

      result[property.applicationType][property.propertyType] = property.value;
    });
  });

  return result;
});
</script>

<template>
  <div class="ce-technicalPropertyCard ce-technicalPropertyCard--chromaHue">
    <div class="flex items-center mb3">
      <TechnicalPropertyInfo
        property-type="chroma" />
      &nbsp;/&nbsp;
      <TechnicalPropertyInfo
        property-type="hue" />
    </div>

    <div class="innerCardsWrapper">
      <div
        class="ce-technicalPropertyCard"
        v-for="(values, applicationType) in byApplicationType"
        :key="`chroma_hue_${applicationType}`">
        <ChromaHueChart
          :application-type="applicationType"
          :values="values"
          :color="color" />
      </div>
    </div>
  </div>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-technicalPropertiesByMedium {
  .ce-technicalPropertiesWrapper {
    .ce-technicalPropertyCard--chromaHue {
      .innerCardsWrapper {
        .ce-technicalPropertyCard {
          background: @color-mono-88;
        }
      }

      .ce-chromaHueChart {
        .applicationType {
          margin-bottom: @space-2;
          .ms(-1);
          font-weight: 600;
        }

        canvas {
          width: 100%;
          height: 300px;
        }
      }

      @media screen and (min-width: @breakpoint-xl) {
        grid-column: span 2;

        .innerCardsWrapper {
          display: flex;
          gap: @space-2;
        }
      }

      @media screen and (min-width: @breakpoint-xxl) {
        grid-column: span 3;
      }
    }
  }
}
</style>
